var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09717 11.528C9.09717 10.9527 9.56354 10.4863 10.1388 10.4863H19.8611C20.4363 10.4863 20.9027 10.9527 20.9027 11.528V18.4724C20.9027 19.0477 20.4363 19.5141 19.8611 19.5141H10.1388C9.56354 19.5141 9.09717 19.0477 9.09717 18.4724V11.528Z",
    stroke: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27075 11.3115L14.3225 15.6361C14.7124 15.9699 15.2874 15.9699 15.6773 15.6361L20.7291 11.3115",
    stroke: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.de4059838e7e10d33987cd8e03c49d5d.svg";
export { ForwardRef as ReactComponent };